<script>
    import { Container, RoundMock, DemoButton } from '@/components'
</script>

<Container innerStyle="pointer-events: none;">
    <h1>Employee<br/> <span>Gate</span></h1>

    <div class="wrapper">
        <div class="content">
            <h2>Автоматизируем кадровые<br/>
                процессы, чтобы освободить<br/>
                время для важных задач
            </h2>

            <div class="description">
                <p>EmployeeGate — личный кабинет сотрудника для работы<br/>
                с документами и удалённого решения кадровых<br/>
                вопросов. Синхронизируется с «1С:ЗУП» и поддерживает<br/>
                электронный документооборот.</p>
                <p>Упростит работу компаний от 10 человек из любых сфер<br/>
                бизнеса. А если сотрудников больше 100 и они работают<br/>
                в филиалах в разных городах и удалённо, то портал<br/>
                просто необходим.
                </p>
            </div>
            
            <div class="button-wrapper">
                <DemoButton />
            </div>
        </div>
    </div>

    <div slot="background" class="background">
        <div class="laptop">
            <video class="video" controls autoplay>
                <source src="./video/laptop.mp4" type="video/mp4">
            </video>
        </div>
        <div class="gradient" />
    </div>
</Container>

<style lang="scss">
    h1 {
        margin-top: 0;
        padding-top: 62px;
        font-size: 123.705px;
        line-height: 155px;
        pointer-events: all;

        br {
            display: none;
        }

        @media (max-width: 1279px) {
            font-size: 90px;
            line-height: 82px;

            br {
                display: block !important;
            }
        }

        @media (max-width: 834px) {
            font-size: 49px;
            line-height: 44px;
        }

        span {
            color: #f39549;
        }
    }

    .wrapper {
        display: flex;
        align-items: top;
        margin-top: 61px;
        width: min-content;
        pointer-events: all;

        @media (max-width: 834px) {
            margin-top: 325px;
        }

        .content {
            width: 100%;
            min-width: 648px;

            @media (max-width: 834px) {
                max-width: 100%;
                min-width: unset;
            }

            .description {
                margin-top: 38px;
                margin-bottom: 55px;

                @media (max-width: 1279px) {
                    width: 100%;

                    br {
                        display: none;
                    }
                }
            }

            .button-wrapper {
                margin-bottom: 120px;
            }
        }
    }

    .background {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        overflow-x: hidden;

        .laptop {
            position: absolute;
            top: 150px;
            right: 5vw;
            width: calc(100% - 5vw);
            height: calc(100% - 150px);
            background-image: url('../img/hero-laptop.png');
            background-repeat: no-repeat;
            background-size: 750px 840px;
            background-position: top right;

            @media (max-width: 1640px) {
                right: -5vw;
                width: 100%;
            }

            @media (max-width: 1500px) {
                right: -8vw;
                width: 100%;
            }

            @media (max-width: 1279px) {
                right: calc(1280px - 99.9%);
                background-size: 650px 728px;
            }

            @media (max-width: 834px) {
                right: 0;
                height: 379px;
                width: auto;
                width: 331px;
                background-size: 100%;
            }
            
            .video {
                position: absolute;
                top: 144px;
                right: 134px;
                width: 430px; 
                height: 320px;
                border-radius: 10px;
                object-fit: fill;
                
                @media (max-width: 1279px) {
                    top: 126px;
                    height: 276px;
                    right: 118px;
                    width: 370px;
                    border-radius: 8px;
                }

                @media (max-width: 834px) {
                    top: 62px;
                    height: 144px;
                    right: 60px;
                    width: 188px;
                }
            }
        }
        
        .gradient {
            position: absolute;
            top: 0;
            right: 0;
            width: calc(350px + ((100% - 1280px) / 2));
            min-width: 450px;
            height: calc(100% - 150px);
            margin-left: auto;
            background-image: url('../img/gradients/hero.jpg');
            background-repeat: no-repeat;
            background-size: cover;
            background-position: bottom;
            z-index: -1;

            @media (max-width: 834px) {
                height: 450px;
                border-radius: 0 0 0 40px;
                width: calc((369 / 834) * 100%);
                min-width: unset;
            }

            @media (max-width: 420px) {
                width: calc((79 / 320) * 100%);
            }
        }
    }
</style>